import { render, staticRenderFns } from "./campaign-express-add.vue?vue&type=template&id=88ca20fc&scoped=true&"
import script from "./campaign-express-add.vue?vue&type=script&lang=js&"
export * from "./campaign-express-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ca20fc",
  null
  
)

export default component.exports